import { REST_METHOD, REST_URL } from './restConstants';

import { KNOWLEDGE } from './knowledgeConstants';

import { DEVICE, EXCEPTION_TYPES } from './deviceConstants';

import { AUTH } from './authConstants';

import { LANGUAGE, LANGUAGE_KEY } from './languageConstants';

import { PC_PROCESSING, EXCEPTION_TYPE, APPROVAL_REQUIRED, DEFAULT_EMPLOYEE_TYPE, NEW_DEVICE_REQUEST_CANCEL_REASONS } from './pcProcessingWorkFlowConstants';

import { EDIT_PROFILE } from './editProfileConstants';
import { CONFIG } from './configConstants';
import { VDA_TYPE, RELEASE_TYPE } from './vdaConstants';

/**
 * Global app constants. We should try our best to not
 * overload this file.
 */

export * from './localStorageConstants';

export * as MARKETPLACE from './marketplaceConstants';

export * from './emailConstants';

export const ACT_ON_BEHALF = "ACT_ON_BEHALF";

export const PORTAL_NAME = JSON.parse(localStorage.getItem(AUTH.CONFIGURATION) || '{}')?.portalName || "UPtime";

export const nodeEnv = {
  test: 'test',
  development: 'development',
  production: 'production',
};

export const OPTIONS = {
  OTHER: 'Other',
}
export {
  KNOWLEDGE,
  REST_URL,
  REST_METHOD,
  AUTH,
  LANGUAGE,
  LANGUAGE_KEY,
  PC_PROCESSING,
  EXCEPTION_TYPE,
  APPROVAL_REQUIRED,
  DEFAULT_EMPLOYEE_TYPE,
  NEW_DEVICE_REQUEST_CANCEL_REASONS,
  EDIT_PROFILE,
  CONFIG,
  DEVICE,
  VDA_TYPE,
  RELEASE_TYPE,
  EXCEPTION_TYPES
};
